var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "meat-content" },
    [
      _c(
        "el-button",
        {
          staticStyle: { "margin-bottom": "20px" },
          attrs: { size: "mini", type: "primary" },
          on: {
            click: function ($event) {
              return _vm.meatLists.push({ selectProduct: [], selectNum: null })
            },
          },
        },
        [_vm._v("新增组合")]
      ),
      _vm._v(" "),
      _vm._l(_vm.meatLists, function (item, i) {
        return _c("el-card", { key: i, staticClass: "meat-item" }, [
          _c(
            "div",
            {
              staticClass: "flex",
              staticStyle: { "justify-content": "space-between" },
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", [_vm._v("组合" + _vm._s(i + 1))]),
              _vm._v(" "),
              i > 0
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.removeMeat(i)
                        },
                      },
                    },
                    [_vm._v("删除该组合")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex mb-20" },
            [
              _c("div", { staticClass: "head" }, [_vm._v("组合名称：")]),
              _vm._v(" "),
              _c("el-input", {
                staticStyle: { width: "90%" },
                attrs: { placeholder: "组合名称" },
                model: {
                  value: _vm.meatLists[i].comboName,
                  callback: function ($$v) {
                    _vm.$set(_vm.meatLists[i], "comboName", $$v)
                  },
                  expression: "meatLists[i].comboName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex mb-20" }, [
            _c("div", { staticClass: "head" }, [_vm._v("组合图片：")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "upLoadPicBox",
                on: {
                  click: function ($event) {
                    return _vm.modalPicTap("1", i)
                  },
                },
              },
              [
                _vm.meatLists[i].image
                  ? _c("div", { staticClass: "pictrue" }, [
                      _c("img", { attrs: { src: _vm.meatLists[i].image } }),
                    ])
                  : _c("div", { staticClass: "upLoad" }, [
                      _c("i", { staticClass: "el-icon-camera cameraIconfont" }),
                    ]),
              ]
            ),
            _vm._v(" "),
            _vm.meatLists[i].image
              ? _c("i", {
                  staticClass: "el-icon-delete",
                  staticStyle: { color: "red", "font-size": "16px" },
                  on: {
                    click: function ($event) {
                      return _vm.removeImg(i)
                    },
                  },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex mb-20",
              staticStyle: {
                "align-items": "flex-start",
                "margin-bottom": "20px",
              },
            },
            [
              _c("div", { staticClass: "head" }, [_vm._v("选择商品：")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-col", staticStyle: { width: "90%" } },
                [
                  _c("SelectSku", {
                    ref: "selectProductsRef",
                    refInFor: true,
                    model: {
                      value: _vm.meatLists[i].selectProduct,
                      callback: function ($$v) {
                        _vm.$set(_vm.meatLists[i], "selectProduct", $$v)
                      },
                      expression: "meatLists[i].selectProduct",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticClass: "table",
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.meatLists[i].selectProduct,
                        size: "mini",
                        "highlight-current-row": "",
                        "header-cell-style": { fontWeight: "bold" },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "id",
                          label: "skuId",
                          "min-width": "150",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "skuCode",
                          label: "sku编码",
                          "min-width": "180",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "skuName",
                          label: "名称",
                          "min-width": "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "price", label: "供货价" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", "min-width": "120" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlerDelete(
                                          i,
                                          scope.row.id
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex mb-20" }, [
            _c("div", { staticClass: "head" }, [_vm._v("选择数量：")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex" },
              [
                _vm.meatLists[i].selectProduct &&
                _vm.meatLists[i].selectProduct.length
                  ? [
                      _c("div", { staticClass: "mr10" }, [
                        _vm._v(
                          _vm._s(_vm.meatLists[i].selectProduct.length) + " 选"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          max: _vm.meatLists[i].selectProduct.length,
                          precision: 0,
                          placeholder: "选择数量",
                        },
                        model: {
                          value: _vm.meatLists[i].selectNum,
                          callback: function ($$v) {
                            _vm.$set(_vm.meatLists[i], "selectNum", $$v)
                          },
                          expression: "meatLists[i].selectNum",
                        },
                      }),
                    ]
                  : _c("div", [_vm._v("请选择商品")]),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex" },
            [
              _c("div", { staticClass: "head" }, [_vm._v("组合排序：")]),
              _vm._v(" "),
              _c("el-input-number", {
                attrs: { min: 0, precision: 0, placeholder: "排序" },
                model: {
                  value: _vm.meatLists[i].sort,
                  callback: function ($$v) {
                    _vm.$set(_vm.meatLists[i], "sort", $$v)
                  },
                  expression: "meatLists[i].sort",
                },
              }),
            ],
            1
          ),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }